// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    SpecialRequestItemsFormApiParameter,
    submitSpecialRequestItemsForm,
} from "@keller/App/Services/SpecialRequestItemsService";

type HandlerType = ApiHandler<SpecialRequestItemsFormApiParameter & HasOnSuccess & HasOnError<string>, void>;

export const DispatchBeginSubmitSpecialRequestItems: HandlerType = props => {};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        await submitSpecialRequestItemsForm(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error.errorMessage);
        return false;
    }
};

export const DispatchCompleteSubmitSpecialRequestItems: HandlerType = props => {};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginSubmitSpecialRequestItems,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteSubmitSpecialRequestItems,
    ExecuteOnSuccessCallback,
];

const submitSpecialRequestItems = createHandlerChainRunner(chain, "SubmitSpecialRequestItems");

export default submitSpecialRequestItems;
